(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.holding-report.event
  (:require
   [clojure.edn :as edn]
   [common.time :as c-time]
   [common.util :as cu]
   [frontend.controller.websocket.event :as ws]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as gathering-sub]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [potpuri.core :as p]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::clear-notification
 (fn [{db :db} [_ _report-id]]
   {:db (-> db
            (p/dissoc-in [::gathering-sub/holding-text-rejected?])
            (p/dissoc-in [::gathering-sub/holding-text-submitted?])
            (p/dissoc-in [::gathering-sub/holding-data-rejected?])
            (p/dissoc-in [::gathering-sub/holding-data-submitted?]))}))

(rf/reg-event-fx
 ::text-save-ok
 (fn [{_db :db} _]
   (js/console.log "Holding text SAVE OK")))

(rf/reg-event-fx
 ::text-save-failed
 (fn [{_db :db} [_ _holding-report-id resp]]
   (js/console.log "Holding Text save failed " resp)))

(rf/reg-event-fx
 ::save-holding-report-text
 (fn [{db :db}
      [_ holding-report-id dynamic-path new-value
       complete-path complete-status]]
   (let [rich-content-list (-> (get-in db gathering-sub/holdings-rich-content-list-path)
                               (get holding-report-id))
         holding-report-new-list (->> rich-content-list
                                      (mapv (fn [rich-content-map]
                                              (if (= (:rich-content-completed-path rich-content-map) complete-path)
                                                (assoc rich-content-map
                                                       :completed? (not (cu/blank-value? complete-status))
                                                       :rich-content-completed-at complete-status
                                                       :rich-content new-value)
                                                rich-content-map))))]
     {:db (cond-> db
            dynamic-path
            (assoc-in (into [] (concat editor-sub/holdings-path
                                       [holding-report-id :lp-report-holding/editable-data]
                                       dynamic-path)) new-value)
            complete-path
            (assoc-in (into [] (concat editor-sub/holdings-path
                                       [holding-report-id :lp-report-holding/editable-data]
                                       complete-path)) complete-status)
            (not= rich-content-list holding-report-new-list)
            (assoc-in (into [] (concat gathering-sub/holdings-rich-content-list-path [holding-report-id])) holding-report-new-list))
      ::ws/send {:id         :lp-report-holding/update-text
                 :body       {:report-id       holding-report-id
                              :value-path      dynamic-path
                              :new-value       new-value
                              :complete-path   complete-path
                              :complete-status complete-status}
                 :on-success [::text-save-ok holding-report-id]
                 :on-error   [::text-save-failed holding-report-id]}})))

(rf/reg-event-fx
 ::complete-remaining-texts
 (fn [{db :db} [_ report-id]]
   (let [report-rich-content-list (-> (get-in db gathering-sub/holdings-rich-content-list-path)
                                      (get report-id))
         complete-paths  (->> report-rich-content-list
                              (keep (fn [rich-content-map]
                                      (when-not (:completed? rich-content-map)
                                        (get rich-content-map :rich-content-completed-path))))
                              (vec))
         now-ts (str (c-time/now-millis))
         new-rich-content-list (->> report-rich-content-list
                                    (mapv (fn [rich-content-map]
                                            (if-not (:completed? rich-content-map)
                                              (assoc rich-content-map
                                                     :completed? true
                                                     :rich-content-completed-at now-ts)
                                              rich-content-map))))]
     {:db (assoc-in db (into [] (concat gathering-sub/holdings-rich-content-list-path [report-id]))
                    new-rich-content-list)
      ::ws/send {:id         :lp-report-holding/complete-all-texts
                 :body       {:report-id report-id
                              :complete-paths complete-paths}
                 :on-success [::complete-all-texts-ok report-id]
                 :on-error   [::complete-all-texts-failed]}})))

(rf/reg-event-fx
 ::complete-all-texts-ok
 (fn [{db :db} [_ report-id resp]]
   (let [updated-state (-> resp
                           :body)
         new-state (when (string? updated-state)
                     (edn/read-string updated-state))
         editable-data-path (into [] (concat editor-sub/holdings-path
                                             [report-id :lp-report-holding/editable-data]))]
     (js/console.log "Completing all texts successful : " resp)
     {:db (-> db
              (assoc-in editable-data-path new-state))})))

(rf/reg-event-fx
 ::complete-all-texts-failed
 (fn [{_db :db} [_ err]]
   (js/console.log "Completing all texts failed : " err)))

(rf/reg-event-fx
 ::chart-save-ok
 (fn [{db :db} [_ on-success! editable-path resp]]
   (when (fn? on-success!)
     (on-success!))
   (let [updated-state (-> resp
                           :body)
         new-state (when (string? updated-state)
                     (edn/read-string updated-state))]
     (when new-state
       {:db (-> db
                (assoc-in editable-path new-state))}))))

(rf/reg-event-fx
 ::chart-save-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Holding Chart save failed " resp)))

(rf/reg-event-fx
 ::save-holding-report-chart
 (fn [{db :db}
      [_ holding-report-id on-success! dynamic-path new-value
      ]]
   (let [editable-path (concat editor-sub/holdings-path
                               [holding-report-id :lp-report-holding/editable-data])
         update-path (concat editable-path dynamic-path)
         updated-db (assoc-in db
                     ;; optimistic save
                     update-path
                     new-value)]
     {:db       updated-db
      ::ws/send {:id         :lp-report-holding/update-chart
                 :body       {:report-id  holding-report-id
                              :value-path dynamic-path
                              :new-value  new-value}
                 :on-success [::chart-save-ok on-success! editable-path]
                 :on-error   [::chart-save-failed holding-report-id]}})))

(rf/reg-event-fx
  ::save-holding-report-chart-configs
  (fn [{db :db}
       [_ holding-report-id on-success! dynamic-path new-value
        ]]
    (let [editable-path (concat editor-sub/holdings-path
                                [holding-report-id :lp-report-holding/editable-data])
          update-path (concat editable-path dynamic-path)
          updated-db (assoc-in db
                               ;; optimistic save
                               update-path
                               new-value)]
      {:db       updated-db
       ::ws/send {:id         :lp-report-holding/update-configs
                  :body       {:report-id  holding-report-id
                               :value-path dynamic-path
                               :new-value  new-value}
                  :on-success [::chart-save-ok on-success! editable-path]
                  :on-error   [::chart-save-failed holding-report-id]}})))

(rf/reg-event-fx
 ::submitted-for-review-text-ok
 (fn [{db :db} [_ holding-report-id _]]
   {:db (assoc-in db
         (concat editor-sub/holdings-path
                 [holding-report-id :lp-report-holding/text-status])
         :lp-report-holding.publishing-status/pending-approval)}))

(rf/reg-event-fx
 ::submit-for-review-text-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Holding Submit text for review failed " resp)))


(rf/reg-event-fx
 ::submit-for-review-text-confirm
 (fn [{_db :db} [_ holding-report-id recipients message]]
   {::ws/send {:id         :lp-report-holding/submit-for-review-text
               :body       {:report-id  holding-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::submitted-for-review-text-ok holding-report-id]
               :on-error   [::submit-for-review-text-failed holding-report-id]}}))

(rf/reg-event-fx
 ::submit-for-review-text
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::gathering-sub/holding-text-submitted?] fund-report-id))}))

(rf/reg-event-fx
 ::submitted-for-review-data-ok
 (fn [{db :db} [_ holding-report-id _]]
   {:db (assoc-in db
         (concat editor-sub/holdings-path
                 [holding-report-id :lp-report-holding/data-status])
         :lp-report-holding.publishing-status/pending-approval)}))

(rf/reg-event-fx
 ::submit-for-review-data-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Holding Submit data for review failed " resp)))


(rf/reg-event-fx
 ::submit-for-review-data-confirm
 (fn [{_db :db} [_ holding-report-id recipients message]]
   {::ws/send {:id         :lp-report-holding/submit-for-review-data
               :body       {:report-id  holding-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::submitted-for-review-data-ok holding-report-id]
               :on-error   [::submit-for-review-data-failed holding-report-id]}}))

(rf/reg-event-fx
 ::submit-for-review-data
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::gathering-sub/holding-data-submitted?] fund-report-id))}))

(rf/reg-event-fx
 ::approve-text-ok
 (fn [{db :db} [_ holding-report-id _]]
   {:db (assoc-in db
         (concat editor-sub/holdings-path
                 [holding-report-id :lp-report-holding/text-status])
         :lp-report-holding.publishing-status/approved)}))

(rf/reg-event-fx
 ::approve-text-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Holding Approve text failed " resp)))

(rf/reg-event-fx
 ::approve-text
 (fn [{_db :db} [_ fund-report-id]]
   {::ws/send {:id         :lp-report-holding/approve-text
               :body       {:report-id fund-report-id}
               :on-success [::approve-text-ok fund-report-id]
               :on-error   [::approve-text-failed fund-report-id]}}))


(rf/reg-event-fx
 ::approve-data-ok
 (fn [{db :db} [_ holding-report-id _]]
   {:db (assoc-in db
         (concat editor-sub/holdings-path
                 [holding-report-id :lp-report-holding/data-status])
         :lp-report-holding.publishing-status/approved)}))

(rf/reg-event-fx
 ::approve-data-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Holding Approve data failed " resp)))

(rf/reg-event-fx
 ::approve-data
 (fn [{_db :db} [_ fund-report-id]]
   {::ws/send {:id         :lp-report-holding/approve-data
               :body       {:report-id fund-report-id}
               :on-success [::approve-data-ok fund-report-id]
               :on-error   [::approve-data-failed fund-report-id]}}))

(rf/reg-event-fx
 ::reject-text-ok
 (fn [{db :db} [_ holding-report-id _]]
   {:db (assoc-in db
         (concat editor-sub/holdings-path
                 [holding-report-id :lp-report-holding/text-status])
         :lp-report-holding.publishing-status/wip)}))

(rf/reg-event-fx
 ::reject-text-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Holding Reject text failed " resp)))

(rf/reg-event-fx
 ::reject-text-confirm
 (fn [{_db :db} [_ holding-report-id recipients message]]
   {::ws/send {:id         :lp-report-holding/reject-text
               :body       {:report-id  holding-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::reject-text-ok holding-report-id]
               :on-error   [::reject-text-failed holding-report-id]}}))

(rf/reg-event-fx
 ::reject-text
 (fn [{db :db} [_ _holding-report-id]]
   {:db (assoc-in db [::gathering-sub/holding-text-rejected?] true)}))

(rf/reg-event-fx
 ::reject-data-ok
 (fn [{db :db} [_ holding-report-id _]]
   {:db (assoc-in db
         (concat editor-sub/holdings-path
                 [holding-report-id :lp-report-holding/data-status])
         :lp-report-holding.publishing-status/wip)}))

(rf/reg-event-fx
 ::reject-data-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Holding Reject data failed " resp)))

(rf/reg-event-fx
 ::reject-data-confirm
 (fn [{_db :db} [_ holding-report-id recipients message]]
   {::ws/send {:id         :lp-report-holding/reject-data
               :body       {:report-id  holding-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::reject-data-ok holding-report-id]
               :on-error   [::reject-data-failed holding-report-id]}}))

(rf/reg-event-fx
 ::reject-data
 (fn [{db :db} [_ _holding-report-id]]
   {:db (assoc-in db [::gathering-sub/holding-data-rejected?] true)}))
